// 이미지 클릭 시 화면 전체에 큰 사이즈로 표시하는 lightbox-style 컨트롤러
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay", "image"]

  open(event) {
    const src = event.params.src
    if (!src || !this.hasOverlayTarget) return
    this.imageTarget.src = src
    this.overlayTarget.classList.remove("hidden")
    document.body.style.overflow = "hidden"
  }

  close() {
    if (!this.hasOverlayTarget) return
    this.overlayTarget.classList.add("hidden")
    this.imageTarget.src = ""
    document.body.style.overflow = ""
  }

  closeOnBackdrop(event) {
    if (event.target === event.currentTarget) this.close()
  }

  closeOnEsc(event) {
    if (event.key === "Escape") this.close()
  }
}
